/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

// Each built entry bundle gets one recovery attempt per tab. A failed recovery
// must remain visible rather than trapping the user in a reload loop.
const reloadKey = `chunk-recovery:${import.meta.url}`;

window.addEventListener('vite:preloadError', (event: Event & { payload?: unknown }) => {
  if (
    !(event.payload instanceof Error) ||
    !event.payload.message.startsWith('Failed to fetch dynamically imported module:')
  ) {
    return;
  }

  try {
    if (sessionStorage.getItem(reloadKey)) return;
    sessionStorage.setItem(reloadKey, '1');
  } catch {
    // Without a persistent guard, a reload could loop when storage is blocked.
    return;
  }

  // Preserve the original rejection for diagnostics until navigation completes.
  window.location.reload();
});
